import { render, staticRenderFns } from "./PlanSchool.vue?vue&type=template&id=32972a28&scoped=true&"
import script from "./PlanSchool.vue?vue&type=script&lang=js&"
export * from "./PlanSchool.vue?vue&type=script&lang=js&"
import style0 from "./PlanSchool.vue?vue&type=style&index=0&id=32972a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32972a28",
  null
  
)

export default component.exports